























































import Vue from "vue";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import { state } from "./data/state";
import { computed, onMounted } from "@vue/composition-api";
import EventsSensitivitiesCard from "./card-items/EventsSensitivitiesCard.vue";
import RiskyEventsCard from "./card-items/risky-events-card/RiskyEventsCard.vue";
import ApplicationsCard from "./card-items/ApplicationsCard.vue";
import InformationSharedCard from "./card-items/entities-sharing/InformationSharedCard.vue";
import MIPLabelingCard from "./card-items/MIPLabelingCard.vue";
import InsightsCard from "./card-items/insights-card/InsightsCard.vue";
import InvestigationModal from "./card-items/entity-investigation/InvestigationModal.vue";
import InvestigationCard from "./card-items/entity-investigation/InvestigationCard.vue";
import { UseModal } from "@/components/root/modal";
import { state as inv_state } from "@/views/investigation/data/state";
import { state as overview_state } from "../../data/state";
import MsAndGoogleApplicationsCardVue from "./card-items/MsAndGoogleApplicationsCard.vue";
import { SharedState } from "@/common/state";
export default Vue.extend({
  components: {
    DropDownSimple,
    EventsSensitivitiesCard,
    RiskyEventsCard,
    ApplicationsCard,
    InformationSharedCard,
    InvestigationCard,
    MsAndGoogleApplicationsCardVue,
    //MIPLabelingCard,
    InsightsCard,
  },
  setup() {
    const {
      init,
      loading,
      from_time_frames,
      selected_from_time_frame,
      set_selected_from_time_frame,
    } = state;

    const current_source = computed(
      () => overview_state.current_overview.value.id
    );

    const show_inv_modal = async () => {
      await UseModal().show(InvestigationModal);
    };

    const is_google_or_ms_only = computed(() => {
      return (
        SharedState.in_motion_services_flags.value.is_google_org_only ||
        SharedState.in_motion_services_flags.value.is_ms_org_only
      );
    });

    const is_google_and_ms = computed(() => {
      return SharedState.in_motion_services_flags.value.is_ms_and_google_org;
    });

    onMounted(() => {
      init();
      inv_state.init("");
    });
    return {
      current_source,
      is_google_and_ms,
      is_google_or_ms_only,
      loading,
      show_inv_modal,
      from_time_frames,
      selected_from_time_frame,
      set_selected_from_time_frame,
    };
  },
});
